import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type LiStyleProps = { disabled?: boolean };

const liStyle = (props?: LiStyleProps) => [
  css`
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: ${theme.spacing(2)};
    text-transform: capitalize;
    transition: background-color 250ms ease-out;

    :hover,
    :focus {
      background-color: ${theme.colors.neutral10};
      outline: none;
    }

    :not(:last-of-type) {
      border-bottom: 1px solid ${theme.colors.neutral20};
    }
  `,
  props?.disabled &&
    css`
      background-color: ${theme.colors.status.disabled};
      cursor: default;
      pointer-events: none;
      opacity: 0.5;
      :hover,
      :focus {
        background-color: ${theme.colors.status.disabled};
        outline: none;
      }
    `,
];

const iconStyleObject = css`
  line-height: 1;
  margin-right: ${theme.spacing(1)};
`;

export const FlyoutMenuItemStyles = {
  liStyle: (props: LiStyleProps) => liStyle(props),
  iconStyle: iconStyleObject,
};
